import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TermsAndConditionsFormGroup } from '../../../pages/registration-wizard/registration-wizard-form.helper';
import { ValidatedCheckboxComponent } from '../../common/validated-checkbox/validated-checkbox.component';

@Component({
  selector: 'app-general-terms-and-conditions-step-form',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    ValidatedCheckboxComponent,
  ],
  templateUrl: './general-terms-and-conditions-step-form.component.html',
  styleUrl: './general-terms-and-conditions-step-form.component.scss',
})
export class GeneralTermsAndConditionsStepFormComponent {
  public formGroupInput =
    input.required<FormGroup<TermsAndConditionsFormGroup>>();
  public contractText = input.required<string>();
}
